"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _userProfile = require("user-profile");

var _decorators = require("decorators");

var _AccountList = babelHelpers.interopRequireWildcard(require("./AccountList"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var CourseSessionReplyListItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CourseSessionReplyListItem, _Component);

  function CourseSessionReplyListItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CourseSessionReplyListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CourseSessionReplyListItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      userProfile: (0, _userProfile.getUserProfileNow)()
    };
    return _this;
  }

  babelHelpers.createClass(CourseSessionReplyListItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      (0, _userProfile.getUserProfile)().then(function (value) {
        _this2.setState({
          userProfile: value
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.userProfile) return _react.default.createElement("pre", null, "No user profile");
      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "success",
        overlay: "reply"
      }, _react.default.createElement(_AccountList.default, {
        accounts: this.item.accounts
      }), this.item.accounts.length == 1 ? ' has ' : ' have ', !this.item.participant || this.state.userProfile && this.item.commentOwner.id == this.state.userProfile.id ? null : ' also ', ' replied to ', this.state.userProfile && this.item.commentOwner.id == this.state.userProfile.id ? ' your ' : this.item.accounts.length > 1 || this.item.accounts[0].id != this.item.commentOwner.id ? _react.default.createElement("span", null, _react.default.createElement(_AccountList.Account, {
        account: this.item.commentOwner
      }), "'s") : ' their ', ' ', this.item.commentType, ' on ', _react.default.createElement("span", {
        className: "courseSession"
      }, this.item.catalogItem.title, " - ", this.item.courseSession.title), '.');
    }
  }], [{
    key: "notificationObject",
    value: function notificationObject(_ref) {
      var _this3 = this;

      var item = _ref.item;
      return Promise.all([_List.NotificationItem.notificationObject({
        item: item,
        overlayType: 'success',
        overlay: 'reply'
      }), _AccountList.default.format(item), (0, _userProfile.getUserProfile)()]).then(function (_ref2) {
        var _ref3 = babelHelpers.slicedToArray(_ref2, 3),
            notificationObject = _ref3[0],
            accounts = _ref3[1],
            userProfile = _ref3[2];

        return Object.assign(notificationObject, {
          body: [accounts, item.accounts.length == 1 ? 'has' : 'have', !_this3.item.participant || item.commentOwner.id == userProfile.id ? '' : 'also', 'replied to', item.commentOwner.id == userProfile.id ? 'your' : item.accounts.length > 1 || item.accounts[0].id != _this3.item.commentOwner.id ? "".concat(item.commentOwner.name, "'s") : 'their', item.commentType, 'on', item.catalogItem.title, '-', item.courseSession.title + '.'].join(' ').split(/\s+/g).filter(function (v) {
            return !!v;
          }).join(' ')
        });
      });
    }
  }]);
  return CourseSessionReplyListItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class);
exports.default = CourseSessionReplyListItem;